<template>
<v-container>
    <v-layout row wrap>
      <v-flex xs0 lg2> </v-flex>
      <v-flex xs12 lg8>
          <v-card class="main_card">
            <br />
            <h3>Admin panel</h3>
            <p>
              <br />
              <subscriptionForm subscriptionType='newUser' />
            </p>
          </v-card>
      </v-flex>
      <v-flex xs0 lg2></v-flex>
    </v-layout>
  </v-container>

</template>
<script>
import subscriptionForm from '../Subscription/SubscriptionForm'
export default {
  name: 'AdminPanel',
  components: {
    subscriptionForm
  }
}
</script>
<style>
.main_card {
  padding: 15px;
}
</style>
